import { connect } from "react-redux";
import MainContent from "./MainContent";
import { storeLayoutLocally } from "../../actions/layoutActions";
import type { AppDispatch, RootState } from "../../store";
import type { MainContentProps } from "./MainContent";

const mapStateToProps = (state: RootState) => {
  const {
    id,
    widgetList,
    layout,
    numberOfColumns,
    isLayoutLocked
  } = state.layouts;
  const { isLoggedIn } = state.login;
  const { uid } = state.userDetails;

  return {
    id,
    uid,
    widgetList,
    layout,
    numberOfColumns,
    isLoggedIn,
    isLayoutLocked
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    onLayoutChange: ({
      widgetList,
      layout
    }: Parameters<NonNullable<MainContentProps["onLayoutChange"]>>[0]) => {
      dispatch(storeLayoutLocally({ widgetList, layout: [...layout] }));
    }
  };
};

const MainContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainContent);

export default MainContentContainer;
